var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"disabled":_vm.items.length === 0},on:{"click":_vm.downloadCSV}},[_vm._v("CSVダウンロード")])}
var staticRenderFns = []

export { render, staticRenderFns }